
const DefaultHeader = () => {
  return(
    <header className="text-4xl p-4 bg-green-50">
      QR-survey
    </header>
  )
}
export default DefaultHeader;